<template>
  <div class="hello">
    
  

<div style="background-color:#e5e5e5;padding:15px;text-align:center;">
  <h1>Avcom Manufacturing > About Us</h1>
  <h3>Avcom Manufacturing: Who we are.</h3>
  
</div>

<div style="overflow:auto">
  <div class="menu">
  <router-link to = "/" class = "main-links" style ="  text-decoration: none;  "> Home</router-link>
    <router-link to = "/AboutUs" class = "main-links" style ="  text-decoration: none;  ">About Us</router-link>
    <router-link to = "/BakingIngredients" class = "main-links" style ="  text-decoration: none;  ">Our Baking Ingredients</router-link>
    <router-link to = "/ContactUs" class = "main-links" style ="  text-decoration: none;  ">Contact Us</router-link>
  </div>

  <div class="main">
    <hr/>
    <h2 style = "color: white; background-color: grey">WHERE WE CAME FROM</h2>
      <hr/>
   <p style = "color: white">AVCOM was established in 2018 with the opening of a retail shop at corner Cameroon and Albion. 
     AVCOM gets most of its products from very reputable companies from outside of Zimbabwe. 
     <p style = "color: white">By that period, we had only a fairly reputable number of supply in Harare.  
       By 2019, we come to realize that the majority of the populace is now getting to familiarize 
       with our supply. We extended our level of ingredients’ supply. </p>
      <p style = "color: white"> We now extended the size of our retail and we are now supplying on a big scale. 
       AVCOM has consistently modernized its product offerings and benefits from its wide distribution network.
       In the period 2020 to 2021, we were working on rebranding our products introducing our own packages
        rather than pre-packaged to best suit the interest of each and every individual client. 
        This has been achieved in good faith and we are now working on opening of many branches nationwide.</p>
  </div>

  <div class="right">
      <hr/>
    <h2 style = "background-color: grey">BAKING INGDREDIENTS</h2>
      <hr/>
    <p>AVCOM specializes in supply of fresh baking ingredients. Every flavor is delivered to you in
       good faith. We have a growing range of consumer baking ingredients of all kind. 
       AVCOM provide products that brings a difference. </p>
  </div>
</div>
<hr/>
<div style="width:60%; height: 400px auto; border: 2px solid black; border-radius: 15px; color: white; margin: 0 auto;">
    <hr/>
  <h2 style = "background-color: grey">MISSION STATEMENT</h2>
    <hr/>
  <ol>
    <li>	To ensure maximization of all stakeholders through provision of personalized service.</li>
    <br/>
    <br/>
 <li>To ensure transparent in delivering our products to different stakeholders.</li>
 <br/>
 <br/>
 <li>To deliver our products with due diligence</li>
 <br/>
 <br/>
 <li>To uphold professionalism and behavioral ethics in quality deliverance.</li>
 <br/>
 <br/>
 <li>	To show and uphold passion in delivering our products</li>

  </ol>
</div>
<hr/>
<div style="width:60%; height: 400px auto; border: 2px solid black; border-radius: 15px; color: white; margin: 0 auto;">
    <hr/>
  <h2 style = "background-color: grey">VISION</h2>
    <hr/>
 <br/>
 <br/>
<h3>To become a competent provider of all baking ingredients through provision of bakers’ requirements.</h3>
<br/><br/>
  <hr/>
<h2 style = "background-color: grey"> MOTTO </h2>
  <hr/>
<br/>
<br/>
<h3>Strong ingredients that make a difference in your baking process.</h3>
<br/>
<br/>
  <hr/>
<h2 style = "background-color: grey">GOALS</h2>
  <hr/>
<br/>
<br/>

 <h3>1.  To be one of the market leaders in the supply of baking ingredients.</h3>
 <h3>2.  To achieve zero defects in all our supplies</h3>
 <h3>3.  To ensure a worth return to our shareholders investment.</h3>

  
  
</div>
<footer>
  <div style="background-color:#e5e5e5;text-align:center;padding:10px;margin-top:7px;">
        <p>OUR PHYSICAL ADDRESSES:</p>
        <p>92 Cameroon Street </p>
        <p>Harare </p>
        <p>White House Building First Floor </p>
        <p>Shop Number 10</p>
        <hr/>
       <p> 1557 Dzivarasekwa Extension</p>
       <p> Dzivarasekwa</p>
       <p> Harare</p>
       <h3> FOR WHATSAPP CHAT CLICK ANY ONE ICON BELOW:   </h3>
        <P><a href="https://api.whatsapp.com/send/?phone=%2B263719327994&text&app_absent=0"><img src ="../assets/whatsapp.png" width ="80px"/></a></P>
        <p>OR</p>
        
            <p><a href="https://api.whatsapp.com/send/?phone=%2B263777327994&text&app_absent=0"><img src ="../assets/whatsapp.png" width ="80px"/></a></P>
        <br/>
                <h3> FOLLOW US ON OUR FACEBOOK PAGE   </h3>
                        <br/>

        <a href="https://www.facebook.com/Avcom-manufacturing-pvt-ltd-101934582241773/"><img src="../assets/facebook.png" width="80"></a>         


    </div>
    <hr/>
<div style="background-color:#e5e5e5;text-align:center;padding:10px;margin-top:7px;">&copy; LearAdlib.com 2021</div>
</footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

* {
  box-sizing: border-box;
}

.menu {
  float: left;
  width: 20%;
  text-align: center;
}
.main-links:hover{

background-color: black;
color:white;
}

.menu a {
  background-color: #e5e5e5;
  padding: 8px;
  margin-top: 7px;
  display: block;
  width: 100%;
  color: black;
}
.hello{
   background-image: linear-gradient(olivedrab, purple);
  width: 100%;
  padding-bottom: 10px;
  padding-top: 5px;
  padding-left: 2px;
  padding-right: 2px
}
.main {
  float: left;
  width: 60%;
  padding: 0 20px;
}

.right {
  background-color: #e5e5e5;
  float: left;
  width: 20%;
  padding: 15px;
  margin-top: 7px;
  text-align: center;
}

@media only screen and (max-width: 620px) {
  /* For mobile phones: */
  .menu, .main, .right {
    width: 100%;
  }
}
</style>

